import { fetchWithAuth } from "../../auth/auth";
import type { Notebook, NotebookFormData } from "../../type/notebook";
import { getApiUrl } from "../../utils/getApiUrl";


export const notebookService = {
  getNotebooks: async (iduser: number, idlanguage: number): Promise<Notebook[]> => {
    const response = await fetchWithAuth(
      getApiUrl(`tools/notebooks?iduser=${iduser}&idlanguage=${idlanguage}`)
    );
    
    if (!response.ok) {
      throw new Error('Failed to fetch notebooks');
    }
    
    return response.json();
  },

  addNotebook: async (iduser: number, data: NotebookFormData, idlanguage: number, onSuccess?: () => void): Promise<void> => {
    const response = await fetchWithAuth(getApiUrl('tools/notebooks'),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          iduser,
          idlanguage,
          ...data,
          public: data.isPublic
        })
      }
    );
    
    if (!response.ok) {
      throw new Error('Failed to add notebook');
    }
    
    if (onSuccess) {
      onSuccess();
    }
  },

  updateNotebook: async (idnotebook: number, data: NotebookFormData, onSuccess?: () => void): Promise<void> => {
    const response = await fetchWithAuth(
      getApiUrl(`tools/notebooks/${idnotebook}`),
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...data,
          public: data.isPublic
        })
      }
    );
    
    if (!response.ok) {
      throw new Error('Failed to update notebook');
    }
    
    if (onSuccess) {
      onSuccess();
    }
  },

  deleteNotebook: async (idnotebook: number, iduser: number, onSuccess?: () => void): Promise<void> => {
    const response = await fetchWithAuth(
      getApiUrl(`tools/notebooks/${idnotebook}?iduser=${iduser}`),
      {
        method: 'DELETE'
      }
    );
    
    if (!response.ok) {
      throw new Error('Failed to delete notebook');
    }
    
    if (onSuccess) {
      onSuccess();
    }
  }
};